// Imports
import { Base, DataTypes } from '@mixins/forms'
import GtkSubmit from '../../mixins/gtk-submit'
import GtkError from '../../mixins/gtk-error'

// Parts
const { ObjectDataType: dataType } = DataTypes
const submitType = GtkSubmit
const errorHandling = GtkError

// Options
const options = {
  name: 'upgrade-wifi-form',
  dataType,
  submitType,
  errorHandling,
  submitOnChange: false,
  skipValidation: false,
  nativeSubmit: true
}

// Component
export default {
  name: options.name,
  mixins: [
    Base(options),
  ],
  computed: {
    gtkMethod() {
      return 'upgradewifi'
    }
  }
}